import {
  ApolloClient,
  createHttpLink,
  from,
  InMemoryCache,
  NormalizedCacheObject,
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { setContext } from "@apollo/client/link/context";

import { buildWebPath } from "lib/resource-finder";
import { getWWRedirectUrl } from "utils/helper";

let apolloClient: ApolloClient<NormalizedCacheObject> | undefined;

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      keyFields: ["uuid"],
    },
  },
});

const httpLink = createHttpLink({
  uri: getWWRedirectUrl("/graphql"),
  // TODO: review changes
  credentials: "omit",
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, extensions }) => {
      if (extensions?.code === 401) {
        window.location.assign(buildWebPath("/login"));
      }
    });
  }
});

const authHeader = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const accessTokenObject = localStorage.getItem("okta-token-storage");
  const authToken = accessTokenObject && JSON.parse(accessTokenObject);
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: authToken?.accessToken?.accessToken
        ? `Bearer ${authToken?.accessToken?.accessToken}`
        : "",
    },
  };
});

export function getApolloClient(): ApolloClient<NormalizedCacheObject> {
  if (!apolloClient) {
    apolloClient = new ApolloClient({
      link: from([authHeader, errorLink, httpLink]),
      cache,
    });
  }

  return apolloClient;
}
